import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

const REPORT_COLUMNS = [
  { label: 'Tenant', key: 'tenant' },
  { label: 'Tcode', key: 'tcode' },
  { label: 'Location', key: 'location' },
  { label: 'Category', key: 'category' },
  { label: 'Subcategory', key: 'subcategory' },
  { label: 'Invoice Number', key: 'invoice_number' },
  { label: 'Date', key: 'date' },
  { label: 'Time', key: 'time' },

  { label: 'Item Total', key: 'item_total', format: 'number' },
  { label: 'Discount', key: 'discount', format: 'number' },
  { label: 'Gross', key: 'gross', format: 'number' },
  { label: 'Tax', key: 'tax', format: 'number' },
  { label: 'Net', key: 'net', format: 'number' }
];

const InvoicewiseSalesReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [startDate, setStartDate] = useState(getYesterdayDate());
    const [endDate, setEndDate] = useState(getYesterdayDate());
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [ReportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };


    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });


    const generateReport = async (e) => {
        e.preventDefault();

        // Validation for start date and end date
        if (endDate < startDate) {
            setValidationMessage('End date cannot be less than start date');
            return;
        } else {
            setValidationMessage('');
        }

        const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
        const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
        const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';
        const tenant_name = tenant_id !== '' ? tenants.find(tenant => tenant._id === tenant_id).tenant_store_name : '';

        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: startDate,
            end_date: endDate,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            tenant_id: selectedTenants,
        };

        setLoading(true)
        axios
            .post(`${config.hostname}/reports/getinvoicewisesalesreport`, data, configheader)
            .then((response) => {
                setReportData(Array.isArray(response.data) ? response.data : []);
                setLoading(false)
                insertToLog(" generated Invoicewise report")
                console.log(response.data);
            })
            .catch((error) => {
                toast.error('Error');
                setLoading(false)
                console.log(error);
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }


    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    // const handleTenantChange = (e) => {
    //     setTenantId(e.target.value);
    //     setReportData([]);
    //     setCurrentPage(0);
    // };


    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });

        setReportData([]);
        setCurrentPage(0);
    };


    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(ReportData.length / itemsPerPage);

    const totals = REPORT_COLUMNS.reduce((acc, col) => {
        if (col.format === 'number') {
            acc[col.key] = ReportData.reduce(
            (sum, row) => sum + (Number(row[col.key]) || 0),
            0
            );
        }
        return acc;
    }, {});

    const sortedReportData = React.useMemo(() => {
        let sortableData = [...ReportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [ReportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };


    const handleExport = (format) => {
        if (ReportData.length > 0) {
            if (format === 'excel') {
                exportToExcel();
                insertToLog(" exported Daywise report to excel");
            } else if (format === 'pdf') {
                exportToPDF();
                insertToLog(" exported Daywise report to pdf")
            }
        }
    };


  const exportToExcel = () => {
  const worksheet = XLSX.utils.aoa_to_sheet([]);

  // 🔹 Title
  XLSX.utils.sheet_add_aoa(worksheet, [['Invoicewise Sales Report']], { origin: 'A1' });
  worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: REPORT_COLUMNS.length - 1 } }];

  // 🔹 Metadata
  const metadata = [
    startDate === endDate ? ['Date', startDate] : ['From', startDate],
    ...(startDate !== endDate ? [['To', endDate]] : []),
    ['Property', property_id ? properties.find(p => p._id === property_id)?.property_name : 'All'],
    ['Category', category_id ? categories.find(c => c._id === category_id)?.category_name : 'All'],
    ['Subcategory', subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All'],
    ['Group', group_name || 'All'],
    ['Exported By', login_name],
    ['Exported On', new Date().toLocaleString()]
  ];

  XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A2' });

  // 🔹 Headers
  const startRow = metadata.length + 3;
  const headers = REPORT_COLUMNS.map(col => col.label);
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: `A${startRow}` });

  // 🔹 Data
  const rows = ReportData.map(row =>
    REPORT_COLUMNS.map(col => row[col.key] ?? '')
  );
  XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: `A${startRow + 1}` });

  // 🔹 Total row
  const totalRow = REPORT_COLUMNS.map(col => col.format === 'number' ? totals[col.key] : '');
  totalRow[0] = 'Total';
  XLSX.utils.sheet_add_aoa(worksheet, [totalRow], {
    origin: `A${startRow + rows.length + 1}`
  });

  worksheet['!cols'] = REPORT_COLUMNS.map(col => ({
    wch: col.format === 'number' ? 16 : 22
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Report');
  XLSX.writeFile(workbook, 'InvoicewiseSalesReport.xlsx');
};

const exportToPDF = () => {
  const doc = new jsPDF('l', 'pt', 'a4');

  doc.setFontSize(14);
  doc.text('Invoicewise Sales Report', 40, 30);

  doc.setFontSize(9);

  const metaY = 50;
  const meta = [
    startDate === endDate ? `Date: ${startDate}` : `From: ${startDate}  To: ${endDate}`,
    `Property: ${property_id ? properties.find(p => p._id === property_id)?.property_name : 'All'}`,
    `Category: ${category_id ? categories.find(c => c._id === category_id)?.category_name : 'All'}`,
    `Subcategory: ${subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All'}`,
    `Group: ${group_name || 'All'}`,
    `Exported By: ${login_name}`,
    `Exported On: ${new Date().toLocaleString()}`
  ];

  meta.forEach((m, i) => doc.text(m, 40, metaY + i * 14));

  const tableBody = ReportData.map(row =>
    REPORT_COLUMNS.map(col => row[col.key] ?? '')
  );

  tableBody.push(
    REPORT_COLUMNS.map(col =>
      col.format === 'number' ? totals[col.key] : ''
    )
  );

  doc.autoTable({
    startY: metaY + meta.length * 14 + 10,
    head: [REPORT_COLUMNS.map(col => col.label)],
    body: tableBody,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [0, 71, 178], textColor: 255 },
    theme: 'grid'
  });

  doc.save('InvoicewiseSalesReport.pdf');
};



    const reset = () => {
        setStartDate('')
        setEndDate('')
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedTenants([]);
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([])

    }

    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startdate">Start Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={startDate}
                                        max={today} onChange={handleStartDateChange} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="enddate">End Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={endDate}
                                        max={today} onChange={handleEndDateChange} required />
                                </FormGroup>
                                {validationMessage && (
                                    <span className="text-danger">{validationMessage}</span>
                                )}
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>                            
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>                       

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('excel'),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>
                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('pdf'),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>
                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" >
                                <Table style={{ tableLayout: 'auto', whiteSpace: 'nowrap' }}>
                                    <thead>
                                        <tr>
                                        {REPORT_COLUMNS.map(col => (
                                            <th key={col.key} onClick={() => requestSort(col.key)}>
                                            {col.label}
                                            {getSortIcon(col.key)}
                                            </th>
                                        ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentPageData.map((row, index) => (
                                        <tr key={index}>
                                            {REPORT_COLUMNS.map(col => (
                                            <td key={col.key}>
                                                {col.format === 'number'
                                                ? (row[col.key] ?? 0).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                    })
                                                : row[col.key] || ''}
                                            </td>
                                            ))}
                                        </tr>
                                        ))}
                                    </tbody>

                                    {/* ✅ TOTAL ROW */}
                                    <tfoot>
                                        <tr>
                                        <td colSpan={REPORT_COLUMNS.length - Object.keys(totals).length}>
                                            <strong>Total</strong>
                                        </td>

                                        {REPORT_COLUMNS.filter(c => c.format === 'number').map(col => (
                                            <td key={col.key}>
                                            <strong>
                                                {totals[col.key].toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                                })}
                                            </strong>
                                            </td>
                                        ))}
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                            {ReportData.length > 50 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}
                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    );
};

export default InvoicewiseSalesReportView;
